import styled from 'styled-components';

export const Container = styled.div`
  position: sticky;
  bottom: 0;
  right: 0;
  z-index: 99;
  
  width: 100%
  
  margin-top: 0.5rem;
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 1.25rem 1.75rem;

  & > button {
    width: 23rem;
    margin-right: 1.5rem;
  }
`;
